import {
	Component,
	OnInit,
	OnDestroy,
	EventEmitter,
	Output,
	ViewChild,
	ElementRef,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { MENU } from './menu';
import { MenuItem } from './menu.model';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {
	menu: any;
	toggle: any = true;
	menuItems: MenuItem[] = [];
	@ViewChild('sideMenu') sideMenu!: ElementRef;
	@Output() mobileMenuButtonClicked = new EventEmitter();
	private routerSub!: Subscription;

	constructor(
		private router: Router,
		public translate: TranslateService,
	) {
		translate.setDefaultLang('en');
	}

	ngOnInit(): void {
		// Menu Items
		this.menuItems = MENU;

		this.routerSub = this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(() => setTimeout(() => this.updateActiveState(), 0));
	}

	ngOnDestroy(): void {
		this.routerSub?.unsubscribe();
	}

	/***
	 * Activate droup down set
	 */
	ngAfterViewInit() {
		this.initActiveMenu();
	}

	removeActivation(items: any) {
		items.forEach((item: any) => {
			if (item.classList.contains('menu-link')) {
				if (!item.classList.contains('active')) {
					item.setAttribute('aria-expanded', false);
				}
				item.nextElementSibling
					? item.nextElementSibling.classList.remove('show')
					: null;
			}
			if (item.classList.contains('nav-link')) {
				if (item.nextElementSibling) {
					item.nextElementSibling.classList.remove('show');
				}
				item.setAttribute('aria-expanded', false);
			}
			item.classList.remove('active');
		});
	}

	toggleSubItem(event: any) {
		let isCurrentMenuId = event.target.closest('a.nav-link');
		let isMenu = isCurrentMenuId.nextElementSibling as any;
		let dropDowns = Array.from(document.querySelectorAll('.sub-menu'));
		dropDowns.forEach((node: any) => {
			node.classList.remove('show');
		});

		let subDropDowns = Array.from(
			document.querySelectorAll('.menu-dropdown .nav-link'),
		);
		subDropDowns.forEach((submenu: any) => {
			submenu.setAttribute('aria-expanded', 'false');
		});

		if (event.target && event.target.nextElementSibling) {
			isCurrentMenuId.setAttribute('aria-expanded', 'true');
			event.target.nextElementSibling.classList.toggle('show');
		}
	}

	toggleExtraSubItem(event: any) {
		let isCurrentMenuId = event.target.closest('a.nav-link');
		let isMenu = isCurrentMenuId.nextElementSibling as any;
		let dropDowns = Array.from(
			document.querySelectorAll('.extra-sub-menu'),
		);
		dropDowns.forEach((node: any) => {
			node.classList.remove('show');
		});

		let subDropDowns = Array.from(
			document.querySelectorAll('.menu-dropdown .nav-link'),
		);
		subDropDowns.forEach((submenu: any) => {
			submenu.setAttribute('aria-expanded', 'false');
		});

		if (event.target && event.target.nextElementSibling) {
			isCurrentMenuId.setAttribute('aria-expanded', 'true');
			event.target.nextElementSibling.classList.toggle('show');
		}
	}

	toggleItem(event: any) {
		let isCurrentMenuId = event.target.closest('a.nav-link');
		let isMenu = isCurrentMenuId.nextElementSibling as any;
		if (isMenu.classList.contains('show')) {
			isMenu.classList.remove('show');
			isCurrentMenuId.setAttribute('aria-expanded', 'false');
		} else {
			let dropDowns = Array.from(
				document.querySelectorAll('#navbar-nav .show'),
			);
			dropDowns.forEach((node: any) => {
				node.classList.remove('show');
			});
			isMenu ? isMenu.classList.add('show') : null;
			const ul = document.getElementById('navbar-nav');
			if (ul) {
				const iconItems = Array.from(ul.getElementsByTagName('a'));
				let activeIconItems = iconItems.filter((x: any) =>
					x.classList.contains('active'),
				);
				activeIconItems.forEach((item: any) => {
					item.setAttribute('aria-expanded', 'false');
					item.classList.remove('active');
				});
			}
			isCurrentMenuId.setAttribute('aria-expanded', 'true');
			if (isCurrentMenuId) {
				this.activateParentDropdown(isCurrentMenuId);
			}
		}
	}

	activateParentDropdown(item: any) {
		item.classList.add('active');
		let parentCollapseDiv = item.closest('.collapse.menu-dropdown');
		if (parentCollapseDiv) {
			// to set aria expand true remaining
			parentCollapseDiv.classList.add('show');
			parentCollapseDiv.parentElement.children[0].classList.add('active');
			parentCollapseDiv.parentElement.children[0].setAttribute(
				'aria-expanded',
				'true',
			);
			if (
				parentCollapseDiv.parentElement.closest(
					'.collapse.menu-dropdown',
				)
			) {
				parentCollapseDiv.parentElement
					.closest('.collapse')
					.classList.add('show');
				if (
					parentCollapseDiv.parentElement.closest('.collapse')
						.previousElementSibling
				)
					parentCollapseDiv.parentElement
						.closest('.collapse')
						.previousElementSibling.classList.add('active');
				if (
					parentCollapseDiv.parentElement
						.closest('.collapse')
						.previousElementSibling.closest('.collapse')
				) {
					parentCollapseDiv.parentElement
						.closest('.collapse')
						.previousElementSibling.closest('.collapse')
						.classList.add('show');
					parentCollapseDiv.parentElement
						.closest('.collapse')
						.previousElementSibling.closest('.collapse')
						.previousElementSibling.classList.add('active');
				}
			}
			return false;
		}
		return false;
	}

	updateActive(event: any) {
		const ul = document.getElementById('navbar-nav');
		if (ul) {
			const items = Array.from(ul.querySelectorAll('a.nav-link'));
			this.removeActivation(items);
		}
		this.activateParentDropdown(event.target);
	}

	initActiveMenu() {
		const ul = document.getElementById('navbar-nav');
		if (!ul) return;

		// Primary: use routerLinkActive result
		let activeItem: Element | null = ul.querySelector('a.nav-link.active');

		// Fallback: match directly by href against current hash
		if (!activeItem) {
			const targetHref = '/' + window.location.hash;
			activeItem = Array.from(ul.querySelectorAll('a[href]')).find((x: any) =>
				x.getAttribute('href') === targetHref,
			) || null;
		}

		// If still not found, don't touch the DOM
		if (!activeItem) return;

		// Collect all ancestor collapse divs so we don't close them
		const ancestorCollapses = new Set<Element>();
		let cursor: Element | null = activeItem.parentElement;
		while (cursor && cursor !== ul) {
			if (cursor.classList.contains('collapse') && cursor.classList.contains('menu-dropdown')) {
				ancestorCollapses.add(cursor);
			}
			cursor = cursor.parentElement;
		}

		// Close only dropdowns outside the active hierarchy
		Array.from(ul.querySelectorAll('.collapse.menu-dropdown.show'))
			.forEach((el: any) => {
				if (!ancestorCollapses.has(el)) {
					el.classList.remove('show');
				}
			});

		// Reset parent links outside the active hierarchy
		Array.from(ul.querySelectorAll('a.is-parent'))
			.forEach((el: any) => {
				const siblingCollapse = el.nextElementSibling;
				if (!siblingCollapse || !ancestorCollapses.has(siblingCollapse)) {
					el.classList.remove('active');
					el.setAttribute('aria-expanded', 'false');
				}
			});

		this.activateParentDropdown(activeItem);
	}

	updateActiveState() {
		const ul = document.getElementById('navbar-nav');
		if (!ul) return;

		// Find the active item via routerLinkActive
		let activeItem: Element | null = ul.querySelector('a.nav-link.active');

		// Fallback: match by href against current hash
		if (!activeItem) {
			const currentHash = window.location.hash;
			activeItem = Array.from(ul.querySelectorAll('a[href]')).find((x: any) =>
				x.hash === currentHash,
			) || null;
		}

		if (!activeItem) return;

		// Reset active on all parent links, then re-apply to the correct one
		ul.querySelectorAll('a.is-parent').forEach((el: any) => el.classList.remove('active'));

		// Re-open the parent collapse if it's not already open
		const parentCollapse = activeItem.closest('.collapse.menu-dropdown');
		if (parentCollapse && !parentCollapse.classList.contains('show')) {
			parentCollapse.classList.add('show');
		}

		this.activateParentDropdown(activeItem);
	}

	/**
	 * Returns true or false if given menu item has child or not
	 * @param item menuItem
	 */
	hasItems(item: MenuItem) {
		return item.subItems !== undefined ? item.subItems.length > 0 : false;
	}

	/**
	 * Toggle the menu bar when having mobile screen
	 */
	toggleMobileMenu(event: any) {
		var sidebarsize =
			document.documentElement.getAttribute('data-sidebar-size');
		if (sidebarsize == 'sm-hover-active') {
			document.documentElement.setAttribute(
				'data-sidebar-size',
				'sm-hover',
			);
		} else {
			document.documentElement.setAttribute(
				'data-sidebar-size',
				'sm-hover-active',
			);
		}
	}

	/**
	 * SidebarHide modal
	 * @param content modal content
	 */
	SidebarHide() {
		document.body.classList.remove('vertical-sidebar-enable');
	}
}
